import { combineReducers } from 'redux';

import { reducer as orgs } from '../slices/orgs';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import areasOfFocus from './areasOfFocus';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import contents from './contents';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import currentUser from './currentUser';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import daysMap from './daysMap';
import error from './error';
import flashMessages from './flashMessages';
import gMapsError from './gMapsError';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import gradSchools from './gradSchools';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import groupDashboard from './groupDashboard';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import groups from './groups';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import idealistDayEvents from './idealistDayEvents';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import internshipFunctions from './internshipFunctions';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import invites from './invites';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import invoices from './invoices';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import jobFunctions from './jobFunctions';
import layout from './layout';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import listingCounts from './listingCounts';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import listings from './listings';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import mainSearch from './mainSearch';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import modal from './modal';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import orgDashboard from './orgDashboard';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import paymentMethods from './paymentMethods';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import postSearch from './postSearch';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import searchRadius from './searchRadius';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import subscribedSubsites from './subscribedSubsites';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import userDashboard from './userDashboard';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import userLocation from './userLocation';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import userNotifications from './userNotifications';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import volopFunctions from './volopFunctions';

const reducers = {
  error,
  gMapsError,
  currentUser,
  userNotifications,
  userLocation,
  paymentMethods,
  invites,
  listingCounts,
  areasOfFocus,
  jobFunctions,
  internshipFunctions,
  volopFunctions,
  orgs,
  listings,
  groups,
  idealistDayEvents,
  mainSearch,
  modal,
  layout,
  searchRadius,
  flashMessages,
  userDashboard,
  orgDashboard,
  groupDashboard,
  invoices,
  contents,
  postSearch,
  gradSchools,
  daysMap,
  subscribedSubsites,
};
export type Reducers = typeof reducers;
export default combineReducers(reducers);
